var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"layout",attrs:{"id":"home","fluid":""}},[_c('b-row',{staticClass:"pb-5 justify-content-center"},[_c('img',{attrs:{"id":"nav-logo","alt":"Zumasys","src":require("@/assets/A-logo-white.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }